import {useEffect, useRef, useState} from "react";
import moment from "moment";


export const Countdown = (props) => {
    const { startDate, endDate } = props
    const [timeLeft,setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    })
    const intervalId = useRef(null)

    useEffect(() => {
        intervalId.current = setInterval(() => {
            if(moment(endDate).isBefore(moment())) {
                setTimeLeft({
                    days: 0,
                    hours: 0,
                    minutes: 0,
                    seconds: 0
                })
                clearInterval(intervalId.current)
                return
            }
            const startTime = startDate || moment()
            const timeRemaining = {}
            timeRemaining.days = moment(endDate).diff(moment(startTime), 'days')
            timeRemaining.hours = moment(endDate).diff(moment(startTime), 'h')%24
            timeRemaining.minutes = moment(endDate).diff(moment(startTime), 'minutes')%60
            timeRemaining.seconds = moment(endDate).diff(moment(startTime), 'seconds')%60
            setTimeLeft(timeRemaining)
        }, 1000)
        return () => {
            clearInterval(intervalId.current)
        }
    }, [])
    return (
        <>
            {<span>{timeLeft.days > 0 ? `${timeLeft.days}z` : ''} {timeLeft.hours > 0 ? `${timeLeft.hours}h ` : ''}</span>}
            <span>{timeLeft.minutes}:{timeLeft.seconds}</span>
        </>
    )

}